/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import LaunchIcon from '@mui/icons-material/Launch';
import { useTranslation } from "react-i18next";
import { MyButton } from "../../components/button/MyButton";
import { withMyTheme } from "../../theme/theme";
import { mobileCss } from "../../util/isMobile";

const LiveDemoButtonStyle = withMyTheme((theme) => css`
  margin-top: 2rem;
  padding: 10px 24px;
  border-radius: 30px;
  font-family: 'Cormorant', serif;
  font-size: 1.4rem;
  text-transform: none;
  margin-bottom: 5vh;
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.primary.contrastText};
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  animation: ${buttonPulse} 2s infinite ease-in-out;
  
  &:hover {
    background-color: ${theme.palette.primary.dark};
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    animation: none;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  ${mobileCss(`
    font-size: 1.1rem;
    padding: 8px 20px;
    margin-top: 1vh;
    margin-bottom: 3vh;
  `)}
`);

const buttonPulse = keyframes`
  0% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 0 20px rgba(196, 85, 38, 0.6);
    scale: 1.05;
  }
  100% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  }
`;

export const LiveDemoButton = ({ openLiveDemo }: { openLiveDemo: () => void }) => {
    const { t } = useTranslation();
    return (
      <MyButton
        variant="primary"
        text={t('features.liveDemoButton')}
        css={LiveDemoButtonStyle}
        onClick={openLiveDemo}
        endIcon={<LaunchIcon />}
      />
    );
  };